<template>
  <div id="app">
    <main>
      <router-view />
    </main>
    <footer>
      <p>© {{ new Date().getFullYear() }} 聊天加解密工具</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  background-color: #f7f7f7;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

header {
  background-color: #07C160;
  color: white;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

header h1 {
  font-size: 24px;
  font-weight: 500;
}

main {
  flex: 1;
}

footer {
  background-color: #f0f0f0;
  padding: 15px;
  text-align: center;
  font-size: 14px;
  color: #666;
}
</style>